export enum StereoMode {
  Mono,
  StereoSideBySide,
  StereoOverUnder,
}
